// calendarConfig.ts
import { dateFnsLocalizer } from "react-big-calendar";
import {
  format as dfFormat,
  parse as dfParse,
  startOfWeek as dfStartOfWeek,
  getDay,
} from "date-fns";
import { es } from "date-fns/locale";

const locales = {
  es: es,
};

export const localizer = dateFnsLocalizer({
  format: (date: Date, formatStr: string, options?: Record<string, unknown>) =>
    dfFormat(date, formatStr, { ...(options || {}), locale: es }),

  parse: (
    value: string,
    formatStr: string,
    referenceDate: Date,
    options?: Record<string, unknown>
  ) => dfParse(value, formatStr, referenceDate, { ...(options || {}), locale: es }),

  startOfWeek: (date: Date, options?: Record<string, unknown>) =>
    dfStartOfWeek(date, { ...(options || {}), locale: es }),

  getDay,
  locales,
});
